export const ICONS = {
  LOGIN_DOOR: 'https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-431-log-in@2x.png',
};
export const LINKS = {
  WAX_SIGNUP: 'https://www.mycloudwallet.com/signin#create-account',
  BUY_PASS: 'https://wax.atomichub.io/market?collection_name=crypto4shots&order=desc&schema_name=early.access&sort=created&symbol=WAX',
};
